module.exports = __webpack_public_path__ + "img/welcome-popup-btn.d02d84da.png";